import { takeEvery } from 'redux-saga/effects'
import { gCall } from './utils'
import api from '../middleware/api'
import * as route from '../routes'
import * as action from '../actions'

function* watchForLoadCampaigns() {
  yield takeEvery(action.CAMPAIGNS_FETCH_INDEX,
    gCall(api.loadCampaigns,
      action.campaignsIndexSucceeded,
      action.campaignsIndexFailed,
    ))
}

function* watchForSelectCampaign() {
  yield takeEvery(action.CAMPAIGN_SELECT_FETCH,
    gCall(api.selectCampaign,
      action.campaignSelectedSucceeded,
      action.campaignSelectedFailed,
      route.campaign_path,
    ))
}

export default [watchForLoadCampaigns, watchForSelectCampaign]



// WEBPACK FOOTER //
// ./src/sagas/campaign.jsx